<!-- 单选框 -->
<template>
    <div v-if="componentsData.type == 6">
        <div class="bg-div" :style="bgStyle">
            <template v-if="componentsData.content.select_style_value == 1">
                <template v-if="componentsData.content.select_style == 1">
                    <div v-if="componentsData.content.title" :style="titleStyle" class="title-box">
                        {{ componentsData.content.title }}
                    </div>
                    <RadioGroup>
                        <Radio
                            v-for="(e, i) in componentsData.content.table_list"
                            :key="i"
                            :label="i"
                            :style="textStyle"
                            >{{ e.name }}</Radio
                        >
                    </RadioGroup>
                </template>
                <template v-else-if="componentsData.content.select_style == 2">
                    <div v-if="componentsData.content.title" :style="titleStyle" class="title-box">
                        {{ componentsData.content.title }}
                    </div>
                    <RadioGroup vertical>
                        <Radio
                            v-for="(e, i) in componentsData.content.table_list"
                            :key="i"
                            :label="i"
                            :style="textStyle"
                            >{{ e.name }}</Radio
                        >
                    </RadioGroup>
                </template>
                <template v-else-if="componentsData.content.select_style == 3">
                    <div v-if="componentsData.content.title" :style="titleStyle" class="title-box">
                        {{ componentsData.content.title }}
                    </div>
                    <RadioGroup type="button" button-style="solid">
                        <Radio
                            v-for="(e, i) in componentsData.content.table_list"
                            :key="i"
                            :label="i"
                            :style="textStyle"
                            >{{ e.name }}</Radio
                        >
                    </RadioGroup>
                </template>
            </template>
            <!-- 图文模式 -->
            <template v-else>
                <div v-if="componentsData.content.title" :style="titleStyle" class="title-box">
                    {{ componentsData.content.title }}
                </div>
                <div class="box-divs">
                    <div
                        v-for="(e, i) in componentsData.content.table_list"
                        :key="i"
                        class="box-div"
                    >
                        <img v-if="e.picview" :src="e.picview" class="box-img">
                        <div v-else class="box-img-none"></div>
                        <div :style="textStyle">{{ e.name }}</div>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        componentsData: {
            type: Object,
            default: {},
        },
    },
    computed: {
        textStyle() {
            const content = this.componentsData.content;
            return {
                color: content.text_color,
            };
        },
        titleStyle() {
            const content = this.componentsData.content;
            return {
                fontSize: `${content.title_size}px`,
                color: content.title_color,
            };
        },
        bgStyle() {
            const content = this.componentsData.content;
            const style = {};
            if (content.bg_color) {
                style.backgroundColor = content.bg_color;
            }
            const bgImg = content.bg_img || {};
            if (bgImg.picview && content.bg_value) {
                style.backgroundImage = `url(${bgImg.picview})`;
            }
            style.padding = `${content.inner_spacing.top}px ${content.inner_spacing.left}px`;
            style.margin = `${content.outer_spacing.top}px ${content.outer_spacing.left}px`;
            style.borderRadius = `${content.rounded_corner_setting.top}px ${content.rounded_corner_setting.top}px ${content.rounded_corner_setting.bottom}px ${content.rounded_corner_setting.bottom}px`;
            return style;
        },
    },
};
</script>

<style scoped>
.bg-div {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
}
.title-box {
    margin-bottom: 8px;
    font-size: 18px;
}
.box-divs {
    display: flex;
    flex-wrap: wrap;
}
.box-div {
    margin-right: 6px;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.box-img {
    margin-bottom: 3px;
    width: 60px;
    height: 60px;
    border-radius: 4px;
}
.box-img-none {
    margin-bottom: 3px;
    width: 60px;
    height: 60px;
    background: #ececec;
    border-radius: 4px;
}
</style>
